module.exports = __webpack_public_path__ + "static/media/datesBadge.82c1b11d.lottie";